var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-viewer-container"},[_c('div',{staticClass:"pdf-viewer"},_vm._l((_vm.pages),function(page){return _c('canvas',{key:page,ref:`canvas-${page}`,refInFor:true,staticClass:"pdf-page"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }